import { useQuery } from '@tanstack/react-query';
import { ErrorManagement } from '@printdeal/error-management/react';
import { ServiceFactory } from '../services/ServiceFactory';
import { AttributeFormat } from '../types/product/ProductRules';
import { DeliveryToolSettings } from '../types/file-delivery/FileDelivery';

const useDeliveryTools = (productKey: string, userSelection: AttributeFormat[], isEnabled: boolean) => useQuery({
  queryKey: ['get-delivery-tools', productKey, JSON.stringify(userSelection)],
  queryFn: async () => {
    try {
      const { deliveryTool } = await ServiceFactory.createProductService().getMerchantRules(
        productKey,
        userSelection,
      );
      return deliveryTool as DeliveryToolSettings;
    } catch (error) {
      ErrorManagement.exception({
        exception: error,
        extra: {
          productKey,
          userSelection: JSON.stringify(userSelection),
        },
        tags: {
          fileLocation: 'useDeliveryTools',
          featureFunction: 'useDeliveryTools',
        },
        fingerprint: ['hooks-use-delivery-tools'],
      });

      throw error;
    }
  },
  enabled: isEnabled,
  retry: 1, // Retry the query once in case of an error
  retryDelay: 1000, // Delay between retry attempts (in milliseconds)
  gcTime: 0, // Set cacheTime to 0 to disable caching for errors
});

export default useDeliveryTools;
